export default {
  FIREFOX: 'FIREFOX',
  CHROME: 'CHROME',
};
